<template>
    <div class="background-image" :style="device !== 'desktop' ? { backgroundImage: `url(${urlImage})` } : { }">
        <img v-if="device === 'desktop'" :alt="altImage" :src="urlImage" />

        <slot></slot>
    </div>
</template>

<script>
import checkDevice from "@/mixins/checkDevice";
import checkResolution from "@/mixins/checkResolution";

export default {
    computed: {
        urlImage: function () {
            const mobilePrefix = this.device !== 'desktop' ? '--mobile' : ''

            return require (`@/assets/img/${this.nameImage}${mobilePrefix}${this.getResolution()}.${this.type}`);
        }
    },
    created: function () {
        this.device = this.getDeviceName(screen)

        window.addEventListener('resize', this.onResize)
    },
    data: () => ({
        device: ''
    }),
    destroyed: function () {
        window.removeEventListener('resize', this.onResize)
    },
    name: "BackgroundImage",
    methods: {
        /**
         * When user resize the screen, it check if device is the same,
         * otherwise some rules will change
         */
        onResize: function () {
            if (this.getDeviceName(screen) !== this.device) {
                this.device = this.getDeviceName(screen)
            }
        }
    },
    mixins: [ checkDevice, checkResolution ],
    props: {
        altImage: String,
        nameImage: String,
        type: String
    }
}
</script>

<style lang="scss">
    .background-image {
        background-position-x: center;
        background-size: cover;
        height: 100%;
        width: 100%;

        img{
            display: none;
        }
    }

    @media (min-width: $desktop-screen) {
        /*
         *
            I chose to use an <img> as Background Image because
            the "background-size: cover" causes many issues
            when there are animations. I am able to handle that problem
            with mobile and tablets because images are less heavy then
            images in desktop devices.
         *
         */

        .background-image {
            background-size: inherit;
            overflow: hidden;
            position: absolute;

            img {
                bottom: 0;
                display: block;
                position: absolute;
                width: 100%;
            }
        }
    }
</style>
